module.exports = __webpack_public_path__ + "img/logo-icon.9d76ddb3.png";